import React, { useEffect } from 'react';
import './SimpleModal.css';

type Props = {
  title?: string;
  children?: React.ReactNode;
  onClose: () => void;
};

const SimpleModal: React.FC<Props> = ({ title, children, onClose }) => {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="sm-modal-overlay" role="dialog" aria-modal="true" aria-label={title || 'Dialog'}>
      <div className="sm-modal">
        <div className="sm-modal-header">
          <strong>{title}</strong>
        </div>
        <div className="sm-modal-body">{children}</div>
        <div className="sm-modal-footer">
          <button className="sm-modal-close" onClick={onClose}>Fermer</button>
        </div>
      </div>
    </div>
  );
};

export default SimpleModal;
